const SPACER_POINT_TOLERANCE = 0.00001;

// Shape points can be rounded while a spacer contour is sorted, so compare with a small tolerance.
const areSpacerPointsEqual = (pointA, pointB) => (
  Math.abs(pointA.x - pointB.x) <= SPACER_POINT_TOLERANCE
  && Math.abs(pointA.y - pointB.y) <= SPACER_POINT_TOLERANCE
);

// A side-edge endpoint is "front" when it belongs to any front line of the source cabinet.
const isPointOnFrontLine = (point, shape) => (
  shape.shapeCabinet
  && shape.shapeCabinet.getFrontLines().some(line => (
    areSpacerPointsEqual(point, line.from) || areSpacerPointsEqual(point, line.to)
  ))
);

// Maps an edge from the pre-sorted spacer contour to its index in the final clockwise contour.
const findLineIndexByPoints = (points, edgePoints) => points.findIndex((point, pointIndex) => {
  const nextPoint = points[(pointIndex + 1) % points.length];
  return (
    areSpacerPointsEqual(point, edgePoints[0])
    && areSpacerPointsEqual(nextPoint, edgePoints[1])
  ) || (
    areSpacerPointsEqual(point, edgePoints[1])
    && areSpacerPointsEqual(nextPoint, edgePoints[0])
  );
});

/**
 * Finds which final spacer edge faces the front of its source cabinet.
 * This keeps the toe-kick on the correct end when the spacer uses one edge of a corner cabinet.
 * Existing rectangular behavior uses line index 2 when no matching front endpoint can be found.
 */
export const getSpacerFrontLineIndex = (shape, point1, point2, adjustedShapePoints, sortedPoints) => {
  const isPoint1OnFront = isPointOnFrontLine(point1, shape);
  const isPoint2OnFront = isPointOnFrontLine(point2, shape);
  let frontEdgePoints = null;

  if (isPoint1OnFront && !isPoint2OnFront) {
    frontEdgePoints = [adjustedShapePoints[2], adjustedShapePoints[3]];
  } else if (isPoint2OnFront && !isPoint1OnFront) {
    frontEdgePoints = [adjustedShapePoints[0], adjustedShapePoints[1]];
  } else if (isPoint1OnFront && isPoint2OnFront) {
    frontEdgePoints = [adjustedShapePoints[1], adjustedShapePoints[2]];
  }

  const frontLineIndex = frontEdgePoints
    ? findLineIndexByPoints(sortedPoints, frontEdgePoints)
    : -1;
  return frontLineIndex >= 0 ? frontLineIndex : 2;
};
